module.exports = __webpack_public_path__ + "img/teacher.b38631ac.png";